import { render } from "./ChildUserDistributionDrawer.vue?vue&type=template&id=48d2cf1e"
import script from "./ChildUserDistributionDrawer.vue?vue&type=script&lang=js"
export * from "./ChildUserDistributionDrawer.vue?vue&type=script&lang=js"

import "./ChildUserDistributionDrawer.vue?vue&type=style&index=0&id=48d2cf1e&lang=scss"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__